import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getIncomeExpenditureReportReq = (action) => {
    const { societyId, fromDate, toDate } = action?.data || {};
    const url = apiEndpoints.GET_INCOME_EXPENDITURE_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { fromDate, toDate } });
}

export const getBalanceSheetReportReq = (action) => {
    const { societyId, toDate } = action?.data || {};
    const url = apiEndpoints.GET_BALANCE_SHEET_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { toDate } });
}

export const getTrialBalanceReportReq = (action) => {
    const { societyId, toDate } = action?.data || {};
    const url = apiEndpoints.GET_TRIAL_BALANCE_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { toDate } });
}

export const getGroupLedgerReportReq = (action) => {
    const { societyId, groupAccountCode, fromDate, toDate } = action?.data || {};
    const url = apiEndpoints.GET_GROUP_LEDGER_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { groupAccountCode, fromDate, toDate } });
}

export const getMonthlyIncomeReportReq = (action) => {
    const { societyId, financialYear, asAtDate } = action?.data || {};
    const url = apiEndpoints.GET_MONTHLY_INCOME_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { financialYear, asAtDate } });
}

export const getMonthlyExpenditureReportReq = (action) => {
    const { societyId, financialYear, asAtDate } = action?.data || {};
    const url = apiEndpoints.GET_MONTHLY_EXPENDITURE_REPORT_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { financialYear, asAtDate } });
}
